import { NgxSpinnerService } from "ngx-spinner";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ICFolder } from "../models/entities/icfolder";
import { ICFolderFilter } from "../models/filters/icfolder.filter";
import { ICFolderApi } from "../models/apis/icfolder.api";
import { BaseDataService } from "./shared/base.data.service";

@Injectable()
export class ICFolderService extends BaseDataService<
  ICFolder,
  ICFolderFilter,
  ICFolderApi
> {
  constructor(
    public dbSrv: NgxIndexedDBService,
    public spinner: NgxSpinnerService,
    public http: HttpClient,
  ) {
    super(dbSrv, spinner, http, ICFolder);
    this.EndPoint = "icfolder";
  }
}
